import React, { Component } from 'react';
import cxs from 'cxs';
import { t } from 'helpers/i18n';
import { CheckBox } from 'elements';
class FieldCheckbox extends Component {
    constructor() {
        super(...arguments);
        this.handleChange = (checked) => {
            this.props.onChange(this.props.name, checked, this.props.column);
        };
    }
    render() {
        const { name, value, required } = this.props;
        return (React.createElement(CheckBox, { label: t(name) + (required ? '*' : ''), checked: value, className: className, onChange: this.handleChange }));
    }
}
export default FieldCheckbox;
const className = cxs({});



//////////////////
// WEBPACK FOOTER
// ./src/elements/FieldCheckbox.tsx
// module id = 375
// module chunks = 0